
import remarkGfm from "remark-gfm";
import Markdown from "react-markdown";

function StandartArticle({ description }) {
  return (
    <div className="mt-2">
      <Markdown remarkPlugins={[remarkGfm]}>{description}</Markdown>
    </div>
  );
}
export default StandartArticle;
